var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 100,
    viewBox: "0 0 107 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_9861)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.959,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.146484 28.8086C25.1283 28.8086 50.11 28.8086 75.0918 28.8086C75.0918 38.4439 75.0918 48.0795 75.0918 57.7148C50.1102 57.9469 25.1283 57.9469 0.146484 57.7148C0.146484 48.0795 0.146484 38.4439 0.146484 28.8086ZM3.66602 30.957C4.56314 30.957 5.46029 30.957 6.35742 30.957C6.35742 38.8346 6.35742 46.7123 6.35742 54.5898C5.46029 54.5898 4.56314 54.5898 3.66602 54.5898C3.66602 46.7123 3.66602 38.8346 3.66602 30.957ZM12.5684 30.957C13.4655 30.957 14.3626 30.957 15.2598 30.957C15.2598 38.8346 15.2598 46.7123 15.2598 54.5898C14.3626 54.5898 13.4655 54.5898 12.5684 54.5898C12.5684 46.7123 12.5684 38.8346 12.5684 30.957ZM21.4707 30.957C22.2988 30.957 23.127 30.957 23.9551 30.957C23.9551 38.8346 23.9551 46.7123 23.9551 54.5898C23.127 54.5898 22.2988 54.5898 21.4707 54.5898C21.4707 46.7123 21.4707 38.8346 21.4707 30.957ZM30.373 30.957C31.2012 30.957 32.0293 30.957 32.8574 30.957C32.8574 38.8346 32.8574 46.7123 32.8574 54.5898C32.0293 54.5898 31.2012 54.5898 30.373 54.5898C30.373 46.7123 30.373 38.8346 30.373 30.957ZM39.2754 30.957C40.1035 30.957 40.9316 30.957 41.7598 30.957C41.7598 38.8346 41.7598 46.7123 41.7598 54.5898C40.9316 54.5898 40.1035 54.5898 39.2754 54.5898C39.2754 46.7123 39.2754 38.8346 39.2754 30.957ZM48.1777 30.957C49.0059 30.957 49.834 30.957 50.6621 30.957C50.6621 38.8346 50.6621 46.7123 50.6621 54.5898C49.834 54.5898 49.0059 54.5898 48.1777 54.5898C48.1777 46.7123 48.1777 38.8346 48.1777 30.957ZM57.0801 30.957C57.9082 30.957 58.7363 30.957 59.5645 30.957C59.5645 38.8346 59.5645 46.7123 59.5645 54.5898C58.7363 54.5898 57.9082 54.5898 57.0801 54.5898C57.0801 46.7123 57.0801 38.8346 57.0801 30.957ZM65.9824 30.957C66.8105 30.957 67.6387 30.957 68.4668 30.957C68.4668 38.8346 68.4668 46.7123 68.4668 54.5898C67.6387 54.5898 66.8105 54.5898 65.9824 54.5898C65.9824 46.7123 65.9824 38.8346 65.9824 30.957Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.974,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.146 50.293C106.146 55.1107 106.146 59.9283 106.146 64.7461C105.977 65.0672 105.701 65.2949 105.318 65.4297C104.009 65.5273 102.698 65.5598 101.385 65.5273C100.77 61.7898 98.4579 59.7717 94.4491 59.4727C90.5789 59.901 88.2672 61.9193 87.5136 65.5273C85.3731 65.5598 83.2339 65.5273 81.0956 65.4297C80.647 65.267 80.3364 64.974 80.164 64.5508C79.9588 53.9227 80.0278 43.3107 80.371 32.7148C80.7484 32.3893 81.1971 32.1939 81.7167 32.1289C88.5432 32.9133 95.3752 33.6619 102.213 34.375C103.108 34.5965 103.522 35.1498 103.455 36.0352C98.2788 36.0025 93.103 36.0352 87.9277 36.1328C87.607 36.3699 87.3656 36.6629 87.2031 37.0117C87.065 39.9414 87.065 42.8711 87.2031 45.8008C87.4803 46.3074 87.9289 46.6004 88.5488 46.6797C93.8622 46.7773 99.1759 46.81 104.49 46.7773C104.762 48.0729 105.314 49.2447 106.146 50.293Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.965,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9629 37.793C93.8627 37.793 98.7623 37.793 103.662 37.793C103.778 40.1461 103.985 42.4898 104.283 44.8242C99.1764 44.8242 94.0697 44.8242 88.9629 44.8242C88.9629 42.4805 88.9629 40.1367 88.9629 37.793Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.895,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.7129 59.4727C76.541 59.4727 77.3691 59.4727 78.1973 59.4727C78.149 61.4971 78.218 63.5152 78.4043 65.5273C77.4381 65.5273 76.4721 65.5273 75.5059 65.5273C75.1516 62.6154 73.4954 60.6949 70.5371 59.7656C72.2989 59.7322 74.0241 59.6346 75.7129 59.4727Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.835,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.18184 59.6684C3.11536 59.636 5.04765 59.6684 6.97871 59.7661C4.39832 60.7022 2.77656 62.4276 2.11348 64.9418C1.67751 64.5752 1.40147 64.1196 1.28535 63.5747C1.18192 62.2743 1.14742 60.9721 1.18184 59.6684Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.883,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9121 59.8628C14.5342 59.6359 18.1917 59.6032 21.8848 59.7652C18.9265 60.6944 17.2702 62.615 16.916 65.5269C16.571 65.5269 16.2259 65.5269 15.8809 65.5269C15.4338 62.6962 13.7775 60.8081 10.9121 59.8628Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.885,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6113 59.8637C27.7133 59.6695 29.8526 59.6043 32.0293 59.6683C32.0637 61.1021 32.0293 62.5344 31.9258 63.9652C30.9676 65.739 30.4155 65.674 30.2695 63.7699C29.3905 61.7353 27.8377 60.4332 25.6113 59.8637Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.887,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4865 59.6684C47.627 59.636 49.7663 59.6684 51.9045 59.7661C49.1857 60.8008 47.4606 62.6563 46.7287 65.3325C46.2405 65.0348 45.861 64.6442 45.59 64.1606C45.4865 62.6647 45.4521 61.1672 45.4865 59.6684Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8379 59.8628C59.4599 59.6359 63.1175 59.6032 66.8105 59.7652C63.9322 60.6577 62.2414 62.5132 61.7383 65.3316C61.4575 65.5034 61.147 65.5687 60.8066 65.5269C60.3584 62.6952 58.7022 60.8071 55.8379 59.8628Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.952,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59926 61.4257C12.4535 61.2192 14.4893 63.3677 13.7067 67.871C12.0543 70.778 9.60444 71.5917 6.35708 70.3124C3.90601 68.5175 3.31943 66.2714 4.59731 63.5741C5.39579 62.5913 6.39643 61.8751 7.59926 61.4257Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.955,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2989 61.4259C26.0375 61.007 28.2457 62.5371 28.9239 66.0158C28.3268 69.7703 26.0495 71.3328 22.0919 70.7033C18.7522 69.064 17.8896 66.6226 19.504 63.3791C20.2911 62.5074 21.2228 61.8562 22.2989 61.4259Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.952,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3184 61.4256C54.9949 60.9805 57.0307 61.8268 58.4258 63.9647C59.6324 67.9006 58.1143 70.2444 53.8712 70.9959C49.8121 70.3703 48.225 68.1569 49.1094 64.3553C49.7473 62.9395 50.8168 61.9629 52.3184 61.4256Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.953,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2248 61.4254C71.8097 61.1607 73.9144 63.1791 73.5393 67.48C72.3279 70.2812 70.1541 71.3554 67.0178 70.7027C63.5954 69.0795 62.7327 66.638 64.4299 63.3785C65.1709 62.447 66.1025 61.7959 67.2248 61.4254Z",
    fill: "#D11116"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.951,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1035 61.4254C97.481 61.0959 99.5857 62.984 99.418 67.0895C98.7712 69.5217 97.115 70.8238 94.4492 70.9957C91.2804 70.6754 89.5896 69.0152 89.377 66.0152C89.6542 63.7586 90.8964 62.2285 93.1035 61.4254Z",
    fill: "#D11116"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_9861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 100,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.64e10c0e80ba2122dc7d72bb4e60323f.svg";
export { ForwardRef as ReactComponent };